module.exports = __webpack_public_path__ + "1792395595471/images/NFC.df81e26.svg";